import { createStore } from 'vuex';
import myself from '@/services/store/modules/myself';
import account from './modules/account';
import apiKeys from './modules/apiKeys';

const isNotProduction = window.FINANCE.modeOverride !== 'prod';

export default createStore({
  modules: {
    account,
    apiKeys,
    myself,
  },
  // https://vuex.vuejs.org/guide/strict.html#strict-mode
  strict: isNotProduction,
});
